import { render, staticRenderFns } from "./IconRnc.vue?vue&type=template&id=ea968e60"
import script from "./IconRnc.vue?vue&type=script&lang=js"
export * from "./IconRnc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports